import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  "aria-hidden": "true",
  "data-pc-section": "maskicon",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m13.941 6.748.006.012a.62.62 0 0 1 0 .504 10.7 10.7 0 0 1-1.28 2.071.6.6 0 0 1-.788.14.6.6 0 0 1-.155-.876Q12.299 7.844 12.73 7c-.472-.92-2.39-4.199-5.734-4.199q-.542.002-1.071.112a.6.6 0 0 1-.256-1.167 6 6 0 0 1 1.327-.144c4.595 0 6.79 4.807 6.944 5.146M2.203 1.617a.6.6 0 0 1 .42.16l9.596 9.597a.6.6 0 0 1-.847.848l-.864-.864a6.34 6.34 0 0 1-3.51 1.04c-4.595 0-6.79-4.807-6.945-5.146L.048 7.24a.6.6 0 0 1 0-.472A10.5 10.5 0 0 1 2.51 3.361l-.736-.736a.6.6 0 0 1 .428-1.008m5.25 6.734L5.686 6.576v-.04a1.39 1.39 0 0 0 .32 1.496 1.45 1.45 0 0 0 1.447.32M1.263 7c.472.912 2.383 4.198 5.734 4.198a5.2 5.2 0 0 0 2.647-.703L8.357 9.207A2.591 2.591 0 0 1 4.79 5.64L3.359 4.21A9.6 9.6 0 0 0 1.263 7",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }